import { useState, useCallback } from 'react';
// BACKEND TEMPORARILY DISABLED - FRONTEND ONLY MODE
// import { API_URL } from '../config/constants';
// import apiService from '../services/apiService';

// Mock data for frontend-only mode
const MOCK_POSTS = [
  {
    _id: '1',
    title: 'Welcome to KOGK Christian Ministry',
    content: 'Join us for worship, fellowship, and spiritual growth. Our doors are always open to welcome you into our church family.',
    author: 'KOGK Ministries',
    type: 'announcement',
    createdAt: new Date().toISOString()
  },
  {
    _id: '2',
    title: 'Sunday Service Schedule',
    content: 'Join us every Sunday for morning worship service. Come as you are and experience God\'s love.',
    author: 'KOGK Ministries',
    type: 'newsletter',
    createdAt: new Date(Date.now() - 86400000).toISOString()
  }
];

export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'info') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  }, []);

  return { notification, showNotification };
};

export const usePosts = (showNotification) => {
  const [posts, setPosts] = useState(MOCK_POSTS);
  const [loading, setLoading] = useState(false);

  const fetchPosts = useCallback(async () => {
    console.log('🔄 FRONTEND-ONLY MODE: Using mock posts data');
    // BACKEND DISABLED - Using mock data instead
    // try {
    //   const response = await fetch(`${API_URL}/posts`);
    //   const data = await response.json();
    //   setPosts(data);
    // } catch (error) {
    //   console.error('Error fetching posts:', error);
    //   showNotification('Unable to load posts. Please check your connection.', 'error');
    // }

    // Simulate loading and return mock data
    setLoading(true);
    setTimeout(() => {
      setPosts(MOCK_POSTS);
      setLoading(false);
    }, 300);
  }, [showNotification]);

  const addPost = useCallback(async (newPost) => {
    if (!newPost.title.trim() || !newPost.content.trim()) {
      showNotification('Please fill in both title and content fields.', 'error');
      return false;
    }

    setLoading(true);

    // BACKEND DISABLED - Simulate adding post with mock data
    // try {
    //   const response = await fetch(`${API_URL}/posts`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(newPost)
    //   });

    //   if (!response.ok) throw new Error('Failed to create post');

    //   const post = await response.json();
    //   setPosts(prevPosts => [post, ...prevPosts]);
    //   showNotification('Post added successfully!', 'success');
    //   return true;
    // } catch (error) {
    //   showNotification('Error adding post. Please try again.', 'error');
    //   return false;
    // } finally {
    //   setLoading(false);
    // }

    // Simulate creating post with mock data
    setTimeout(() => {
      const mockPost = {
        ...newPost,
        _id: Date.now().toString(),
        author: 'KOGK Ministries',
        createdAt: new Date().toISOString()
      };
      setPosts(prevPosts => [mockPost, ...prevPosts]);
      setLoading(false);
      showNotification('Post added successfully!', 'success');
    }, 500);

    return true;
  }, [showNotification]);

  return { posts, setPosts, loading, fetchPosts, addPost };
};

/*
export const useStreamSettings = (showNotification) => {
  const [streamActive, setStreamActive] = useState(false);
  const [facebookLiveUrl, setFacebookLiveUrl] = useState('');

  const fetchStreamSettings = useCallback(async () => {
    try {
      const data = await apiService.getStreamStatus();
      setStreamActive(data.active);
      setFacebookLiveUrl(data.facebookLiveUrl || '');
    } catch (error) {
      console.error('Error fetching stream settings:', error);
    }
  }, []);

  const updateStreamSettings = useCallback(async (active, url = facebookLiveUrl) => {
    try {
      await apiService.updateStreamStatus({ active, facebookLiveUrl: url });
    } catch (error) {
      console.error('Error updating stream settings:', error);
    }
  }, [facebookLiveUrl]);

  const toggleStream = useCallback(async () => {
    const newState = !streamActive;
    setStreamActive(newState);
    await updateStreamSettings(newState);
    showNotification(
      newState ? 'Stream started!' : 'Stream stopped.',
      newState ? 'success' : 'info'
    );
  }, [streamActive, updateStreamSettings, showNotification]);

  const checkFacebookLive = useCallback(async () => {
    try {
      showNotification('Checking for Facebook Live streams...', 'info');
      const response = await fetch(`${API_URL}/facebook/live-check`);
      const data = await response.json();

      if (data.success) {
        if (data.liveVideos && data.liveVideos.length > 0) {
          // Live stream detected
          setStreamActive(data.streamSettings.active);
          setFacebookLiveUrl(data.streamSettings.facebookLiveUrl || '');

          const liveVideo = data.liveVideos[0];
          showNotification(
            `🔴 Live Stream Found: "${liveVideo.title || data.streamSettings.title}"`,
            'success'
          );

          return {
            found: true,
            video: liveVideo,
            embedUrl: data.streamSettings.facebookLiveUrl
          };
        } else {
          // No live streams found
          showNotification('No active Facebook Live streams found', 'info');

          // If current stream was auto-detected, turn it off
          if (data.streamSettings && data.streamSettings.autoDetected) {
            setStreamActive(false);
          }

          return {
            found: false,
            message: 'No active streams'
          };
        }
      } else {
        throw new Error(data.error || 'Failed to check Facebook Live');
      }
    } catch (error) {
      console.error('Error checking Facebook Live:', error);
      showNotification(
        'Unable to check Facebook Live. Please check your setup or try again later.',
        'error'
      );
      return {
        found: false,
        error: error.message
      };
    }
  }, [showNotification]);

  const fetchStreamStatus = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/stream/status`);
      const data = await response.json();

      if (data.success) {
        setStreamActive(data.stream.active || false);
        setFacebookLiveUrl(data.stream.facebookLiveUrl || '');

        return {
          stream: data.stream,
          facebook: data.facebook,
          isConnected: data.facebook?.connected || false,
          isLive: data.facebook?.isLive || false
        };
      }
    } catch (error) {
      console.error('Error fetching stream status:', error);
      return null;
    }
  }, []);

  return {
    streamActive,
    setStreamActive,
    facebookLiveUrl,
    setFacebookLiveUrl,
    fetchStreamSettings,
    fetchStreamStatus,
    updateStreamSettings,
    toggleStream,
    checkFacebookLive
  };
};
*/

export const useContactForm = (showNotification) => {
  const [contactForm, setContactForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);

  const sendMessage = useCallback(async () => {
    if (!contactForm.name.trim() || !contactForm.email.trim() || !contactForm.message.trim()) {
      showNotification('Please fill in all fields.', 'error');
      return false;
    }

    if (!contactForm.email.includes('@')) {
      showNotification('Please enter a valid email address.', 'error');
      return false;
    }

    setLoading(true);

    // BACKEND DISABLED - Simulate sending message
    // try {
    //   const response = await fetch(`${API_URL}/contact`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(contactForm)
    //   });

    //   if (!response.ok) throw new Error('Failed to send message');

    //   setContactForm({ name: '', email: '', message: '' });
    //   showNotification('Thank you for your message! We\'ll get back to you soon.', 'success');
    //   return true;
    // } catch (error) {
    //   showNotification('Error sending message. Please try again.', 'error');
    //   return false;
    // } finally {
    //   setLoading(false);
    // }

    // Simulate sending contact message
    setTimeout(() => {
      console.log('📧 DEMO MODE: Contact message sent', contactForm);
      setContactForm({ name: '', email: '', message: '' });
      setLoading(false);
      showNotification('Thank you for your message! We\'ll get back to you soon.', 'success');
    }, 1000);

    return true;
  }, [contactForm, showNotification]);

  return {
    contactForm,
    setContactForm,
    loading,
    sendMessage
  };
};

// Mock events data
const MOCK_EVENTS = [
  {
    _id: '1',
    title: 'Sunday Worship Service',
    description: 'Join us for our weekly worship service',
    date: new Date(Date.now() + 7 * 86400000).toISOString().split('T')[0],
    time: '10:00 AM',
    location: 'KOGK Christian Ministry',
    type: 'service',
    recurring: 'weekly'
  },
  {
    _id: '2',
    title: 'Bible Study',
    description: 'Weekly Bible study and discussion',
    date: new Date(Date.now() + 3 * 86400000).toISOString().split('T')[0],
    time: '7:00 PM',
    location: 'KOGK Christian Ministry',
    type: 'community',
    recurring: 'weekly'
  }
];

export const useEvents = (showNotification) => {
  const [events, setEvents] = useState(MOCK_EVENTS);
  const [loading, setLoading] = useState(false);

  const fetchEvents = useCallback(async () => {
    console.log('📅 FRONTEND-ONLY MODE: Using mock events data');
    // BACKEND DISABLED - Using mock data instead
    // try {
    //   setLoading(true);
    //   const response = await fetch(`${API_URL}/events`);
    //   const data = await response.json();
    //   setEvents(data);
    // } catch (error) {
    //   console.error('Error fetching events:', error);
    //   showNotification('Unable to load events. Please check your connection.', 'error');
    // } finally {
    //   setLoading(false);
    // }

    setLoading(true);
    setTimeout(() => {
      setEvents(MOCK_EVENTS);
      setLoading(false);
    }, 300);
  }, [showNotification]);

  const addEvent = useCallback(async (eventData) => {
    if (!eventData.title.trim() || !eventData.date || !eventData.time.trim()) {
      showNotification('Please fill in title, date, and time fields.', 'error');
      return false;
    }

    setLoading(true);

    // BACKEND DISABLED - Simulate adding event
    // try {
    //   const response = await fetch(`${API_URL}/events`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(eventData)
    //   });

    //   if (!response.ok) throw new Error('Failed to create event');

    //   const event = await response.json();
    //   setEvents(prevEvents => [event, ...prevEvents]);
    //   showNotification('Event added successfully!', 'success');
    //   return true;
    // } catch (error) {
    //   showNotification('Error adding event. Please try again.', 'error');
    //   return false;
    // } finally {
    //   setLoading(false);
    // }

    // Simulate creating event with mock data
    setTimeout(() => {
      const mockEvent = {
        ...eventData,
        _id: Date.now().toString(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      setEvents(prevEvents => [mockEvent, ...prevEvents]);
      setLoading(false);
      showNotification('Event added successfully!', 'success');
    }, 500);

    return true;
  }, [showNotification]);

  const updateEvent = useCallback(async (eventId, eventData) => {
    setLoading(true);

    // BACKEND DISABLED - Simulate updating event
    // try {
    //   const response = await fetch(`${API_URL}/events/${eventId}`, {
    //     method: 'PUT',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(eventData)
    //   });

    //   if (!response.ok) throw new Error('Failed to update event');

    //   const updatedEvent = await response.json();
    //   setEvents(prevEvents =>
    //     prevEvents.map(event =>
    //       event._id === eventId ? updatedEvent : event
    //     )
    //   );
    //   showNotification('Event updated successfully!', 'success');
    //   return true;
    // } catch (error) {
    //   showNotification('Error updating event. Please try again.', 'error');
    //   return false;
    // } finally {
    //   setLoading(false);
    // }

    // Simulate updating event
    setTimeout(() => {
      const updatedEvent = {
        ...eventData,
        _id: eventId,
        updatedAt: new Date().toISOString()
      };
      setEvents(prevEvents =>
        prevEvents.map(event =>
          event._id === eventId ? updatedEvent : event
        )
      );
      setLoading(false);
      showNotification('Event updated successfully!', 'success');
    }, 500);

    return true;
  }, [showNotification]);

  const deleteEvent = useCallback(async (eventId) => {
    setLoading(true);

    // BACKEND DISABLED - Simulate deleting event
    // try {
    //   const response = await fetch(`${API_URL}/events/${eventId}`, {
    //     method: 'DELETE'
    //   });

    //   if (!response.ok) throw new Error('Failed to delete event');

    //   setEvents(prevEvents => prevEvents.filter(event => event._id !== eventId));
    //   showNotification('Event deleted successfully!', 'success');
    //   return true;
    // } catch (error) {
    //   showNotification('Error deleting event. Please try again.', 'error');
    //   return false;
    // } finally {
    //   setLoading(false);
    // }

    // Simulate deleting event
    setTimeout(() => {
      setEvents(prevEvents => prevEvents.filter(event => event._id !== eventId));
      setLoading(false);
      showNotification('Event deleted successfully!', 'success');
    }, 300);

    return true;
  }, [showNotification]);

  return {
    events,
    loading,
    fetchEvents,
    addEvent,
    updateEvent,
    deleteEvent
  };
};
